import styles from './StatusBadge.module.css';

export type PslLevel = 'High' | 'Medium' | 'Low';

const CLASS: Record<PslLevel, string> = {
  High: styles.high,
  Medium: styles.medium,
  Low: styles.low,
};

export function StatusBadge({ level }: { level: PslLevel }) {
  return (
    <span className={`${styles.badge} ${CLASS[level]}`} data-psl={level}>
      <span className={styles.label}>{level}</span>
    </span>
  );
}
